window.Sticky = new Sticky('[data-sticky]');

(function ($) {

    $(function () {

        //offsets sticky elements (powered through sticky-js library) to compensate for current height of other sticky elements
        window.offsetStickyElements = function () {

            var secondaryNavigationElement = $('.endicott-secondary-navigation-mobile');
            var headerElement = $('.header-wrapper');
            var $ancillaryNavElement = $('.endicott-header-ancillary-nav-container-outer');

            var offset = 0;

            if (secondaryNavigationElement.length && secondaryNavigationElement.is(":visible")) {
                offset += $(secondaryNavigationElement).outerHeight();
            }

            if (headerElement.length && headerElement.is(":visible")) {
                offset += $(headerElement).outerHeight();

                if ($ancillaryNavElement.length && $ancillaryNavElement.is(":visible")) {
                    offset -= $ancillaryNavElement.outerHeight();
                }
            }

            if (offset > 0) {
                $('[data-scroll-margin-top]').css("scroll-margin-top", offset);

                $('[data-sticky]').each(function () {
                    var attr = $(this).attr('data-sticky-no-margin');

                    if (typeof attr === 'undefined' || attr === false) {
                        $(this).attr('data-margin-top', offset);
                    }
                });
            }

            // set minimum size of page body to compensate for extra-long secondary navigation
            var $secondaryNavInnerContainer = $(".endicott-secondary-navigation-inner");
            $secondaryNavInnerContainer.each(function () {
                $(".page-body-interior-with-left-nav").css("min-height", $secondaryNavInnerContainer.outerHeight() + "px");
            });

        }

        $(window).on("scroll", $.throttle(100, false, function () {
            offsetStickyElements();
        }));

        $(window).on("resize", $.throttle(100, false, function () {
            offsetStickyElements();
        }));

        offsetStickyElements();

    });

})($JQ);